import { DIALOG_DATA } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { carouselAnimation } from '../../animations/angular-animations/fade';
import { PalantirDialogRef } from '../dialog/dialog-ref.service';
import { PalantirCarouselService } from './carousel.service';
import type { CarouselDialogParams, CarouselSlide, CarouselTexts } from './carousel.types';

@Component({
  selector: 'palantir-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false,
  animations: [carouselAnimation],
})
export class PalantirCarouselComponent {
  public palantirCarouselService = inject(PalantirCarouselService);

  public slides: CarouselSlide[] = [];

  public texts!: CarouselTexts;

  public currentSlide = 0;

  public mediaErrors: { [key: number]: boolean } = {};

  public constructor(
    @Inject(DIALOG_DATA) private readonly data: CarouselDialogParams,
    private readonly palantirDialogRef: PalantirDialogRef,
  ) {
    this.slides = this.data.slides;
    this.texts = this.data.texts;
    this.mediaErrors = this.data.mediaErrors;
    this.currentSlide = this.data.openAt;
  }

  public onPreviousClick() {
    const previous = this.currentSlide - 1;
    this.currentSlide = previous < 0 ? this.slides.length - 1 : previous;
  }

  public onNextClick() {
    const next = this.currentSlide + 1;
    this.currentSlide = next === this.slides.length ? 0 : next;
  }

  public close(): void {
    void this.palantirDialogRef.close();
  }
}
